export default __webpack_public_path__ + "static/media/ninos-Banner-Curso-Word-270x180.045a45b5.png";